import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { ThirdPartyLoginWrapper } from './ThirdPartyLoginElements.styles';
import GoogleLoginButton from './google/GoogleLoginButton';
import { MicrosoftLoginButton } from './microsoft/MicrosoftLoginButton';
import { useMicrosoftLogin } from '../hooks/useMicrosoftLogin';
export const ThirdPartyLoginElements = ({
  onGoogleLoginClick
}) => {
  const {
    isMicrosoftLoginEnabled,
    loginWithMicrosoft
  } = useMicrosoftLogin();
  return isMicrosoftLoginEnabled ? /*#__PURE__*/_jsxs(ThirdPartyLoginWrapper, {
    children: [/*#__PURE__*/_jsx(GoogleLoginButton, {
      onClick: onGoogleLoginClick
    }), isMicrosoftLoginEnabled && /*#__PURE__*/_jsx(MicrosoftLoginButton, {
      onClick: loginWithMicrosoft
    })]
  }) : /*#__PURE__*/_jsx("div", {
    className: "google-login-wrapper",
    children: /*#__PURE__*/_jsx(GoogleLoginButton, {
      onClick: onGoogleLoginClick
    })
  });
};